export enum ClubPaymentPartnerAccountStatusUi {
  NOT_ONBOARDED = 'NOT_ONBOARDED',
  ONBOARDING = 'ONBOARDING',
  VALIDATED = 'VALIDATED',
  IN_ERROR = 'IN_ERROR',
}
